
import request from '@/axios'

export const getMemberList = (query) => {
  return request({
    url: '/lebo-user/member/page',
    method: 'get',
    params: query
  })
}